import { useState } from 'react'

import { randomHex } from 'utils/crypto'
import { useShowAddressGenerator } from 'state/user/hooks'

import { Input, Tooltip } from 'components/ui'

import { GenerateConainer, GenerateTitle, Info, GenerateWrapper, StyledButton } from './Style'

type Props = {
  setList: (list: string) => void
}

const MAX_ADDRESSES_COUNT = 10_000
export function AddressesGenerator({ setList }: Props) {
  const stateAddressGenerator = useShowAddressGenerator()

  const [amount, setAmount] = useState('0.000001')
  const [addressesCount, setAddressesCount] = useState('100')

  const onAddressesCountChange = (value: string) => {
    if (Number(value) > MAX_ADDRESSES_COUNT) {
      setAddressesCount('30000')
    } else {
      setAddressesCount(value)
    }
  }

  const handleGenerateList = () => {
    const length = Number(addressesCount)
    if (isNaN(length)) {
      return
    }

    const data = Array.from({ length }, () => `0x${randomHex(20)}, ${amount}`)
    setList(data.join('\n'))
  }

  return (
    <GenerateConainer isShow={stateAddressGenerator}>
      <GenerateTitle id='generateAddresses'>
        Generate addresses <Info>i</Info>
      </GenerateTitle>
      <Tooltip id='generateAddresses' place='top'>
        If&nbsp;you want to&nbsp;test dApp with a&nbsp;large number of&nbsp;addresses on&nbsp;the test network, you can
        use address generation.
      </Tooltip>

      <GenerateWrapper>
        <Input
          label='_count-addresses'
          type='number'
          inputType='outline'
          inputSize='medium'
          value={addressesCount}
          onChange={onAddressesCountChange}
        />
        <Input
          label='_amount'
          value={amount}
          type='number'
          inputType='outline'
          inputSize='medium'
          onChange={setAmount}
        />

        <StyledButton onClick={handleGenerateList} type='primary'>
          _generate
        </StyledButton>
      </GenerateWrapper>
    </GenerateConainer>
  )
}
